import { render, staticRenderFns } from "./ZimbraMailService.vue?vue&type=template&id=19dd20fc&scoped=true&"
import script from "./ZimbraMailService.vue?vue&type=script&lang=js&"
export * from "./ZimbraMailService.vue?vue&type=script&lang=js&"
import style0 from "./ZimbraMailService.vue?vue&type=style&index=0&id=19dd20fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dd20fc",
  null
  
)

export default component.exports